import { template } from 'utils/helper';

export const url_reports = {
	settlements_with_suppliers: template`reports/agreement/${'slugAgreement'}/settlements-with-suppliers/`,
	agreement_slug_animator_payments: template`reports/agreement/${'slugAgreement'}/animator-payments/`,
	agreement_slug_cashback: template`reports/agreement/${'slugAgreement'}/cashback/`,
	agreement_slug_supplier_payouts: template`reports/agreement/${'slugAgreement'}/supplier-payouts/`,
	agreement_slug_invoices_with_orders: template`reports/agreement/${'slugAgreement'}/invoices-with-orders/`,
	generate_report: 'reports/generate/'
};

const getParams = ({ page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter, values }) => {
	const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;

	const pagination = Object.assign({},
		order && { o: order },
		rowsPerPage && { pageSize: rowsPerPage },
		page && { page: page + 1 }
	);

	const cpValues = { ...values };
	delete cpValues.month;
	delete cpValues.year;
	delete cpValues.isPaid;
	const formValues = Object.assign(cpValues,
		values?.month && { month: values?.month },
		values?.year && { year: values?.year }
	);

	const otherParams = Object.assign({},
		searchParameter && { q: searchParameter }
	);

	return {
		...pagination,
		...formValues,
		...otherParams
	};
};

const reports = service => ({
	getSettlementsWithSuppliers: ({ slugAgreement, page, rowsPerPage, sortParameter, searchParameter, isOrderByAsc, values }) => {
		const otherParams = Object.assign({},
			 { unsettled: values.unsettled ? 1 : 0 }
		);
		return service.get(url_reports.settlements_with_suppliers({ slugAgreement }), {
			params: {
				...getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter, values }),
				...otherParams
			}
		});
	},
	getAnimatorPayments: ({ slugAgreement, page, rowsPerPage, sortParameter, isOrderByAsc, values }) => {
		return service.get(url_reports.agreement_slug_animator_payments({ slugAgreement }), {
			params: getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, values })
		});
	},
	getCashback: ({ slugAgreement, page, rowsPerPage, sortParameter, isOrderByAsc, values }) => {
		return service.get(url_reports.agreement_slug_cashback({ slugAgreement }), {
			params: getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, values })
		});
	},
	getSupplierPayouts: ({ slugAgreement, page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc, values }) => {
		return service.get(url_reports.agreement_slug_supplier_payouts({ slugAgreement }), {
			params: getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter, values })
		});
	},
	getDiscountedInvoices: ({ slugAgreement, page, rowsPerPage, sortParameter, isOrderByAsc, values }) => {
		const otherParams = Object.assign({},
			values?.isPaid && { isPaid: false }
		);
		return service.get(url_reports.agreement_slug_invoices_with_orders({ slugAgreement }), {
			params: {
				...getParams({ page, rowsPerPage, sortParameter, isOrderByAsc, values }),
				...otherParams
			}
		});
	},
	generateReport: ({ values }) => service.post(url_reports.generate_report, values, {
		responseType: 'blob'
	})
	
});

export default reports;
